var $ = require('jQuery');
var Vue = require('vue');
var AccountExistsModal = require('./components/AccountExistsModal.vue').default;
var RegistrationEmail = require('./components/RegistrationEmail').default;
var PhoneField = require('../../lib/components/Fields/PhoneField.vue').default;

module.exports = function () {
  $('.request-login-link-form').hide();

  $('#remembered-password, #back-to-login').click(function (e) {
    e.preventDefault();
    $('.login-form').show();
    $('.password-reminder-form').hide();
    $('.request-login-link-form').hide();
  });

  $('#request-login-link').click(function (e) {
    e.preventDefault();
    $('.request-login-link-form').show();
    $('.login-form').hide();
  });

  $('#forgot-password').click(function (e) {
    e.preventDefault();
    $('.password-reminder-form').show();
    $('.login-form').hide();
  });

  $('input[name="language"]').change(function () {
    var language = $(this).val();
    window.location = window.location.pathname + '?language=' + language;
  });

  var timeout = 20000;

  var recaptchaNotLoaded = function () {
    if (!$('.g-recaptcha').children().length) {
      $('#no-recaptcha').removeClass('hidden');
    }
  };

  var funcaptchaNotLoaded = function () {
    if (!$('#funcaptcha').children().length) {
      $('#funcaptcha').parent('.form-group').children().not('#no-funcaptcha').remove();
      $('#no-funcaptcha').removeClass('hidden');
    }
  };

  if ($('#funcaptcha').length) {
    setTimeout(funcaptchaNotLoaded, timeout);
  } else if ($('.g-recaptcha').length) {
    setTimeout(recaptchaNotLoaded, timeout);
  }

  const modal = document.getElementById('accountExistsModal');

  if (modal) {
    new Vue({
      el: modal,
      components: {
        'account-exists-modal': AccountExistsModal
      }
    });
  }

  const registrationEmail = document.getElementById('registrationEmail');

  if (registrationEmail) {
    new Vue({
      el: registrationEmail,
      components: {
        'registration-email': RegistrationEmail
      }
    });
  }

};
